import Fetch from "./fetchUtils"

export function getScopes() {
    return Fetch.get('api/sm/scopes');
}